module.exports = __webpack_public_path__ + "img/ciencia.757d5fce.jpg";